"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PIMData = _interopRequireDefault(require("./PIMData"));

var _PIMToken = _interopRequireDefault(require("./models/PIMToken"));

var _PIMTokenService = _interopRequireDefault(require("./services/PIMTokenService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var axios = require('axios')["default"];

var PIM = /*#__PURE__*/function () {
  /**
   * @param {PIMConfig} options
   * @param {Object} data
   * @constructor
   * @example
   * import { PIM } from '@demant/pim';
   */
  function PIM(options, data, directPimProducts) {
    _classCallCheck(this, PIM);

    /**
     * @type {PIMConfig}
     * @private
     */
    this.options = options || {};
    this.data = data && new _PIMData["default"](data, null, directPimProducts);
    this.directPimProducts = directPimProducts;
  }
  /**
   * @returns {PIMData}
   */


  _createClass(PIM, [{
    key: "getData",
    value: function getData() {
      return this.data || new _PIMData["default"](null, new Error('No data set for PIM.'), this.directPimProducts);
    }
    /**
     * @returns {PIMToken}
     */

  }, {
    key: "getToken",
    value: function getToken() {
      return _PIMTokenService["default"].instance.getToken();
    }
  }, {
    key: "flushToken",
    value: function flushToken() {
      _PIMTokenService["default"].instance.flushToken();
    }
    /**
     * @returns {Promise<PIMData>}
     */

  }, {
    key: "fetchHearingInstruments",
    value: function fetchHearingInstruments() {
      return this.fetchData(this.options.hearingInstrumentsEndpoint);
    }
    /**
     * @returns {Promise<PIMData>}
     */

  }, {
    key: "fetchAccessories",
    value: function fetchAccessories() {
      return this.fetchData(this.options.accessoriesEndpoint);
    }
    /**
     * @param {string} productId
     * @returns {Promise<PIMData>}
     */

  }, {
    key: "fetchProduct",
    value: function fetchProduct(productId) {
      // eslint-disable-line no-unused-vars
      var promises = [this.fetchData(this.options.productEndpoint), this.fetchData(this.options.relatedAccessoriesEndpoint)];
      return new Promise(function (resolve, reject) {
        Promise.all(promises).then(function (aPimData) {
          var productPimData = aPimData[0];
          var accessoriesPimData = aPimData[1];

          if (productPimData.products && productPimData.products.length) {
            productPimData.products[0].relatedAccessories = accessoriesPimData.products;
          }

          resolve(productPimData);
        })["catch"](reject);
      });
    }
    /**
     * @returns {Promise<PIMData>}
     */

  }, {
    key: "fetchStyles",
    value: function fetchStyles() {
      return this.fetchData(this.options.stylesEndpoint);
    }
    /**
     * @param {string} endpoint
     * @returns {Promise<PIMData>}
     */

  }, {
    key: "fetchData",
    value: function fetchData(endpoint) {
      if (!endpoint) {
        return new Promise(function (resolve) {
          resolve(new _PIMData["default"](null, new Error('No endpoint set in PIM options.')));
        });
      }

      if (this.options.isLocal) {
        return new Promise(function (resolve) {
          try {
            var data = require(endpoint); // eslint-disable-line


            resolve(new _PIMData["default"](data, null));
          } catch (err) {
            resolve(new _PIMData["default"](null, err));
          }
        });
      }

      return axios.get(endpoint).then(function (response) {
        if (response && response.status === 200 && response.data) {
          return new _PIMData["default"](response.data, null);
        }

        return new _PIMData["default"](null, new Error(response.statusText));
      })["catch"](function (error) {
        return new _PIMData["default"](null, error);
      });
    }
  }]);

  return PIM;
}();

var _default = PIM;
/**
 * @typedef {object} PIMConfig
 * @property {string} hearingInstrumentsEndpoint
 * @property {string} accessoriesEndpoint
 * @property {string} productEndpoint
 * @property {string} relatedAccessoriesEndpoint
 * @property {string} stylesEndpoint
 * @property {boolean} isLocal
 * */

exports["default"] = _default;